import { create } from "zustand";

const temporalStore = create((set: any, get: any) => ({
  preselectedAccountForTransfer: "",

  setPreselectedAccountForTransfer: (account: string) => {
    set({ preselectedAccountForTransfer: account });
  },
}));

export default temporalStore;
